export interface BasicSelectListItem {
    id: number;
    uniqueID?: string;
    displayName: string;
    taxable: boolean;
    isDefault: boolean;
    hasPaymentAddress: boolean;
}

export function createBasicSelectListItem(instance?: BasicSelectListItem | any) {
    const obj = <BasicSelectListItem>{
        id: 0,
        displayName: '',
        taxable: true,
        isDefault: false,
        hasPaymentAddress: false
    };
    if (instance) {
        Object.assign(obj, instance);
        if (!obj.uniqueID) {
            obj.uniqueID = instance.uniqueID ?? instance.uniqueId ?? instance.UniqueID;
        }
    }
    return obj;
}